import { StateCreator } from 'zustand'

import { FilterStore, OptionsSlice } from './types'

export const createOptionsSlice: StateCreator<FilterStore, [], [], OptionsSlice> = (set) => ({
  options: {
    ready: false,
    orgTypes: [],
    orgs: [],
    buildings: [],
    schoolYears: [],
    saleTypes: [],
    foodModes: [],
    customerTypes: [],
    salePoints: [],
    employees: [],
    mailItems: [],
    // ADD HERE
  },
  loading: {
    orgTypes: false,
    orgs: false,
    buildings: false,
    schoolYears: false,
    saleTypes: false,
    foodModes: false,
    customerTypes: false,
    salePoints: false,
    employees: false,
    // ADD HERE
  },

  setOptions(values) {
    set((state) => ({
      options: {
        ...state.options,
        ...values,
      },
    }))
  },

  setLoading(key, value) {
    set((state) => ({
      loading: {
        ...state.loading,
        [key]: value,
      },
    }))
  },

  setReady(value) {
    set((state) => ({
      options: {
        ...state.options,
        ready: value,
      },
    }))
  },
})
